import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import AssignmentBtn from './components/AssignmentBtn';
import FirmwareTypeSelect from './components/FirmwareTypeSelect';
import UnassignedFirmwareCheckBox from './components/UnassignedFirmwareCheckBox';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import style from './FirmwareControlPanel.module.scss';

const FirmwareControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<AssignmentBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<FirmwareTypeSelect />
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<UnassignedFirmwareCheckBox />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default FirmwareControlPanel;
